import * as React from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'

import Grid from '@mui/material/Grid'
import SubImportMenuItem from './SubImportMenuItem'
import Container from '@mui/material/Container'

import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import LoadingButton from '@mui/lab/LoadingButton'
import Link from '@mui/material/Link'
import FormHelperText from '@mui/material/FormHelperText'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'

import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import StepButton from '@mui/material/StepButton'

import Typography from '@mui/material/Typography'

import ArrowForwardIcon from '@mui/icons-material/ArrowForwardOutlined'
import MultipleSelect from '../MultiSelect'
import EditableSelect from '../EditableSelect'

import TextField from '@mui/material/TextField'

import { useZustand } from '../../hooks/useZustand'
import {
    useContextsStore,
    selectOwnedContexts,
} from '../../stores/useContextsStore'
import usePageInfo from '../../hooks/usePageInfo'

import { UserContext } from '../../UserContext'

import { useTheme } from '@mui/material/styles'

import { generateNewsImportItems } from './NewsImportItems'

import { SubImportContext } from './SubImportContext'
import { DialogsContext } from '../../DialogsContext'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'

import axios from 'axios'
import Papa from 'papaparse'

import {
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material'

import { useDropzone } from 'react-dropzone'
import {
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
    ListItemSecondaryAction,
} from '@mui/material'
import { InsertDriveFile, Delete } from '@mui/icons-material'
import { slugifyString } from '../../utils'
import ImportingNotice from './ImportingNotice'
import { importErrorMessage } from './importError'

const addPrivateStatementsSelector = state => state.addPrivateStatementsToStore

const steps = ['Files', 'Columns', 'Filters', 'Destination']

export default function CSVFileImportDialog({ presetContext, open, onClose }) {
    const theme = useTheme() // hook to get the current theme

    const { label, location } = usePageInfo()

    const {
        activeSubImportDialog,
        setActiveSubImportDialog,
    } = React.useContext(SubImportContext)

    const { presetFiles, closeImportDialog } = React.useContext(DialogsContext)

    const preSelectedContext = presetContext
        ? presetContext
        : generatePresetContext()

    const [selectedContext, addToSelectedContext] = React.useState(
        preSelectedContext
    )

    const [errorMessage, setErrorMessage] = React.useState(null)

    const [importError, setImportError] = React.useState(null)

    const [selectedFeeds, setSelectedFeeds] = React.useState([])

    const [completedSteps, setCompletedSteps] = React.useState([])

    const [visitedContext, setVisitedContext] = React.useState(false)

    const [filesAsNodes, setFilesAsNodes] = React.useState('0')

    const [filterBySpeakers, setFilterBySpeakers] = React.useState(false)

    const [fileType, setFileType] = React.useState('')

    const [doubleSquareBrackets, setDoubleSquareBrackets] = React.useState('')

    const [squareBrackets, setSquareBrackets] = React.useState('')

    const [advancedSettings, setAdvancedSettings] = React.useState(false)

    const [advancedFilterSettings, setAdvancedFilterSettings] = React.useState(
        false
    )

    const [addColumnNameToFilter, setAddColumnNameToFilter] = React.useState(
        true
    )

    const [delimiter, setDelimiter] = React.useState(';')

    const [doNotSaveGraph, setDoNotSaveGraph] = React.useState(false)

    const [fromInsideContext, setFromInsideContext] = React.useState(false)

    const { username } = React.useContext(UserContext)
    const addPrivateStatementsToStore = useZustand(addPrivateStatementsSelector)
    const contexts = useContextsStore(selectOwnedContexts)

    React.useEffect(() => {
        if (location == 'context' && label) {
            setFromInsideContext(true)
        }
    }, [label])

    const contextNames = contexts.map(c => c.name)

    const handleChange = (_, newValue) => {
        setValue(newValue)
    }

    const [activeStep, setActiveStep] = React.useState(0)
    const [skipped, setSkipped] = React.useState(new Set())

    const isStepOptional = step => {
        return step === 1
    }

    const isStepSkipped = step => {
        return skipped.has(step)
    }

    const handleNext = () => {
        let newSkipped = skipped
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values())
            newSkipped.delete(activeStep)
        }

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(newSkipped)
    }

    const [files, setFiles] = React.useState(presetFiles)

    const [fileContent, setFileContent] = React.useState([]) // To store the parsed content

    const [fileName, setFileName] = React.useState('')
    const [columns, setColumns] = React.useState([])
    const [filters, setFilters] = React.useState([])

    const [removeDuplicates, setRemoveDuplicates] = React.useState(false)

    const [columnForTimestamp, setColumnForTimestamp] = React.useState('none')

    const [universalTag, setUniversalTag] = React.useState('')

    const [splitByColumn, setSplitByColumn] = React.useState('none')

    const [superlinkedColumn, setSuperlinkedColumn] = React.useState('none')

    const [modifyAnalyzedText, setModifyAnalyzedText] = React.useState('none')

    const [replaceEntities, setReplaceEntities] = React.useState(false)

    const fileInputRef = React.useRef()

    React.useEffect(() => {
        if (!presetContext)
            addToSelectedContext(
                generatePresetContext(
                    'csv',
                    slugifyString(fileName).slice(0, 12)
                )
            )
        setUniversalTag(`file: ${slugifyString(fileName).slice(0, 32)}`)
    }, [fileName])

    const onDrop = React.useCallback(acceptedFiles => {
        const droppedFiles = acceptedFiles
        handleAddedFiles(droppedFiles)
    }, [])

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        noClick: true,
        noKeyboard: true,
        // accept: 'application/pdf, text/plain', // Produces an error but looks like it's not necessary
    })

    const onFilesAdded = event => {
        const addedFiles = Array.from(event.target.files)
        handleAddedFiles(addedFiles)
    }

    React.useEffect(() => {
        const existPresetFiles =
            presetFiles && presetFiles.length > 0 ? true : false
        if (existPresetFiles) handleAddedFiles(presetFiles)
    }, [])

    const handleAddedFiles = addedFiles => {
        const uploadedFiles = addedFiles.filter(file => {
            const determinedType = determineFileType(file)
            switch (determinedType) {
                case '.csv':
                    setFileType('csv')
                    break
            }
            return determinedType === '.csv'
        })

        setFiles([...uploadedFiles])

        const reader = new FileReader()

        reader.onload = e => {
            const text = e.target.result // CSV file text

            // Parse CSV file with PapaParse
            Papa.parse(text, {
                complete: result => {
                    console.log('Parsed Result:', result)
                    setFileContent(result.data)
                    setDelimiter(result.meta.delimiter)
                },
                header: true, // This will parse your data as objects with column names as keys
            })
        }

        // Start reading the file as text
        reader.readAsText(uploadedFiles[0])
    }

    const handleColumnSelection = colName => {
        setColumns(prev => {
            if (!prev.includes(colName)) {
                return [...prev, colName]
            } else {
                return prev.filter(c => c !== colName)
            }
        })
    }

    const handleFilterSelection = _colName => {
        let colName = removeUnicodeControls(_colName)
        setFilters(prev => {
            if (!prev.includes(colName)) {
                return [...prev, colName]
            } else {
                return prev.filter(c => c !== colName)
            }
        })
    }

    const handleDelete = fileToDelete => () => {
        setFiles(prevFiles => prevFiles.filter(file => file !== fileToDelete))
    }

    const openFileDialog = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click()
        }
    }

    const fileList = files.reverse().map((file, index) => {
        return (
            <ListItem key={index}>
                <ListItemIcon>
                    <InsertDriveFile />
                </ListItemIcon>
                <ListItemText
                    primary={file.name}
                    secondary={`${file.size} bytes`}
                />
                <ListItemSecondaryAction>
                    <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={handleDelete(file)}
                    >
                        <Delete />
                    </IconButton>
                </ListItemSecondaryAction>
            </ListItem>
        )
    })

    const submitDataForm = () => {
        const formData = new FormData()

        // Append the files to the FormData object
        files.forEach(file => {
            formData.append('uploadedFile', file) // 'files' is the key for the server
        })

        columns.forEach(column => {
            formData.append('processfield', column)
        })

        filters.forEach(filter => {
            formData.append('tagfield', filter)
        })

        formData.append('delimiter', delimiter)

        formData.append('source', 'file')

        formData.append('context', selectedContext)

        formData.append(
            'timestamps',
            columnForTimestamp != 'none' ? columnForTimestamp : ''
        )

        formData.append('namelink', universalTag ? universalTag : '')
        formData.append('includenamelink', universalTag ? '1' : '')

        formData.append(
            'titlefield',
            splitByColumn != 'none' ? splitByColumn : ''
        )

        formData.append(
            'superlinkedColumn',
            superlinkedColumn != 'none' ? superlinkedColumn : ''
        )

        formData.append('removeduplicates', removeDuplicates ? '1' : '0')

        if (doNotSaveGraph) {
            formData.append('doNotSaveGraph', 'true')
        }

        formData.append(
            'modifyAnalyzedText',
            modifyAnalyzedText != 'none' ? modifyAnalyzedText : ''
        )

        if (replaceEntities) {
            formData.append('replaceEntities', 'true')
        }

        if (addColumnNameToFilter == true) {
            formData.append('addColumnNameToFilter', 'true')
        } else {
            formData.append('addColumnNameToFilter', 'false')
        }

        axios
            .post('/import/csv', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // Sending as URL-encoded form data
                },
            })
            .then(response => {
                if (response.data.redirectUrl) {
                    // If you're using window.location
                    window.location.href = response.data.redirectUrl

                    // Or, if you're using React Router's history (assuming you have access to the history object)
                    // history.push(response.data.redirectUrl);
                } else {
                    if (response.data.error) {
                        setErrorMessage(
                            typeof response.data.error == 'object'
                                ? response.data.error.error ||
                                      JSON.stringify(response.data.error)
                                : response.data.error
                        )
                        setImportError(response.data.error)
                        setActiveStep(1)
                    }
                    if (response.data.entryuid) {
                        const postedby = username
                        const res = response.data

                        // Handle private mode statements
                        if (doNotSaveGraph && res.statements) {
                            // Private mode: add statements to Zustand store without saving to DB
                            const entryuids = JSON.parse(res.entryuid)
                            const statementHashtags =
                                res.statementHashtags || {}
                            addPrivateStatementsToStore(
                                res.statements,
                                selectedContext,
                                entryuids,
                                statementHashtags
                            )
                        }

                        if (
                            window.myEventEmitter &&
                            myEventEmitter._events['chatMessage']
                        ) {
                            myEventEmitter.emit('chatMessage', {
                                source: null,
                                postedby: postedby,
                                entryuid: JSON.parse(res.entryuid),
                                entrytext: JSON.parse(res.entrytext),
                                entryname: JSON.parse(res.entryname),
                                tags: JSON.parse(res.tags),
                                timestamp: JSON.parse(res.timestamp),
                                graph: res.graph,
                                stimulateVariability: false,
                                message: res.message,
                                statementHashtags: res.statementHashtags || {},
                                doNotSaveGraph: doNotSaveGraph,
                            })
                            closeImportDialog()
                        }
                    }
                }
            })
            .catch(error => {
                // Handle the error here
                console.error('Received the following error', error)
                setErrorMessage(importErrorMessage(error))
                setImportError(response.data.error)
            })
    }

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1)
    }

    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
            // You probably want to guard against something like this,
            // it should never occur unless someone's actively trying to break something.
            throw new Error("You can't skip a step that isn't optional.")
        }

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(prevSkipped => {
            const newSkipped = new Set(prevSkipped.values())
            newSkipped.add(activeStep)
            return newSkipped
        })
    }

    const handleReset = () => {
        setActiveStep(0)
    }

    React.useEffect(() => {
        if (activeSubImportDialog.content) {
            setActiveStep(1)
            setSelectedFeeds(activeSubImportDialog.content)
        }
    }, [activeSubImportDialog])

    React.useEffect(() => {
        setImportError(null)
    }, [selectedFeeds])

    React.useEffect(() => {
        if (fileType === 'markdown') {
            setDoubleSquareBrackets('PROCESS_AS_MENTIONS')
            setFilesAsNodes('1')
            setSquareBrackets('IGNORE_BRACKETS')
        }
    }, [fileType])

    React.useEffect(() => {
        switch (activeStep) {
            case 1:
                if (files.length > 0) {
                    setCompletedSteps([...completedSteps, 0, 1])

                    if (!presetContext) {
                        addToSelectedContext(
                            generatePresetContext(fileType, fileName)
                        )
                    }
                    break
                }
                setErrorMessage('Please, select at least one file.')
                break
            case 2:
                if (files.length > 0) {
                    if (files[0].name)
                        setFileName(
                            files[0].name.split('.')[0].replace(/ /g, '_')
                        )
                    if (
                        completedSteps.indexOf(1) >= 0 &&
                        columns.length === 0
                    ) {
                        setErrorMessage(
                            `Please, select at least one data column you'd like to import.`
                        )
                        setActiveStep(1)
                        break
                    }
                    setCompletedSteps([...completedSteps, 0, 1])
                    setErrorMessage(null)
                    setVisitedContext(true)

                    break
                }
                setActiveStep(1)
                break
            case 3:
                if (files.length > 0) {
                    if (
                        completedSteps.indexOf(1) >= 0 &&
                        !selectedContext &&
                        visitedContext
                    ) {
                        setErrorMessage(
                            'Please, select the graph to import your data to.'
                        )
                        break
                    }
                    setCompletedSteps([...completedSteps, 0, 1, 2])
                    setErrorMessage(null)
                    setVisitedContext(true)

                    break
                }
                setActiveStep(2)
                break
            case 4:
                if (selectedContext) {
                    setCompletedSteps([...completedSteps, 3])
                    setErrorMessage(null)
                    submitDataForm()
                    break
                }
                setActiveStep(2)
                break
        }
    }, [activeStep])

    const handleStep = step => {
        setActiveStep(step)
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogTitle
                    sx={{
                        padding: 4,
                        color: theme => theme.palette.text.primary,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    {'Analyze the Content of CSV Spreadsheets:'}
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Stepper
                    activeStep={activeStep}
                    sx={{ paddingLeft: 4, paddingRight: 4, paddingTop: 2 }}
                >
                    {steps.map((label, index) => {
                        const stepProps = {}
                        const labelProps = {}
                        // if (isStepOptional(index)) {
                        //     labelProps.optional = (
                        //         <Typography variant="caption">
                        //             Optional
                        //         </Typography>
                        //     )
                        // }
                        if (isStepSkipped(index)) {
                            stepProps.completed = false
                        }
                        return (
                            <Step key={label} {...stepProps}>
                                <StepButton
                                    onClick={() => handleStep(index)}
                                    completed={(
                                        completedSteps.indexOf(index) >= 0
                                    ).toString()}
                                >
                                    <StepLabel
                                        {...labelProps}
                                        sx={{
                                            '& .MuiStepLabel-label': {
                                                fontSize: {
                                                    xs: '0.75rem',
                                                    sm: 'initial',
                                                },
                                            },
                                        }}
                                    >
                                        {label}
                                    </StepLabel>
                                </StepButton>
                            </Step>
                        )
                    })}
                </Stepper>

                {errorMessage && (
                    <Typography
                        sx={{
                            paddingRight: 4,
                            paddingLeft: 4,
                            paddingTop: 4,
                            paddingBottom: 0,
                        }}
                        color="error"
                        component="div"
                        gutterBottom
                    >
                        {errorMessage}
                    </Typography>
                )}

                {activeStep === 0 && (
                    <>
                        <DialogContent
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <Box sx={{ p: 2 }}>
                                <Paper
                                    {...getRootProps()}
                                    onClick={openFileDialog} // Here we make the Paper component click event trigger the input click
                                    sx={{
                                        p: 2,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        height: '200px',
                                        borderStyle: 'dashed',
                                        borderColor: isDragActive
                                            ? 'primary.main'
                                            : 'grey.400',
                                        backgroundColor: isDragActive
                                            ? 'background.default'
                                            : 'background.paper',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <Typography variant="body1">
                                        Drag and drop the .CSV spreadsheet file
                                        you'd like to analyze here, or click to
                                        select and upload manually.
                                    </Typography>

                                    <input
                                        {...getInputProps()}
                                        ref={fileInputRef}
                                        accept="application/vnd.ms-excel, text/csv, .csv"
                                        onChange={onFilesAdded}
                                        style={{ display: 'none' }}
                                        multiple={false}
                                    />
                                </Paper>
                                <Box sx={{ m: 2 }}>
                                    <Button
                                        variant="contained"
                                        component="label"
                                        onClick={openFileDialog}
                                    >
                                        Select & Upload New File
                                    </Button>
                                </Box>

                                <List>{fileList}</List>
                            </Box>
                        </DialogContent>
                    </>
                )}
                {activeStep === 1 && (
                    <>
                        <DialogContent
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <Typography
                                variant="subtitle1" // or another variant appropriate for your design
                                sx={{
                                    fontWeight: 'bold',
                                }}
                            >
                                2. Please, select the columns you would like to
                                analyze
                            </Typography>

                            <Typography
                                variant="subtitle2" // or another variant appropriate for your design
                                sx={{ marginTop: 1, maxWidth: 600 }}
                            >
                                We recommend selecting a single column for long
                                texts, such as reviews, comments, or keyword
                                lists. If you have a single value in each cell,
                                you can select several columns to analyze the
                                relations between them (e.g. source / target).
                            </Typography>

                            <Grid container spacing={8}>
                                <Grid item xs={12} sm={12}>
                                    <Table
                                        sx={{
                                            borderCollapse: 'collapse',
                                            marginTop: 2,
                                        }}
                                    >
                                        <TableHead>
                                            <TableRow variant="head">
                                                {/* Render column headers with checkboxes */}
                                                {fileContent.length > 0 &&
                                                    Object.keys(
                                                        fileContent[0]
                                                    ).map((colName, index) => (
                                                        <TableCell
                                                            key={index}
                                                            sx={{
                                                                border:
                                                                    '1px solid grey', // This line adds the borders
                                                                verticalAlign:
                                                                    'top', // this style aligns content to the top
                                                                whiteSpace:
                                                                    'nowrap', // prevent text from wrapping to the next line
                                                                backgroundColor: theme =>
                                                                    theme
                                                                        .palette
                                                                        .mode ===
                                                                    'dark'
                                                                        ? '#222 !important'
                                                                        : '#ddd !important',
                                                                color: theme =>
                                                                    theme
                                                                        .palette
                                                                        .mode ===
                                                                    'dark'
                                                                        ? '#fff !important'
                                                                        : '#000 !important',
                                                                cursor:
                                                                    'pointer',
                                                            }}
                                                            onClick={() =>
                                                                handleColumnSelection(
                                                                    colName
                                                                )
                                                            }
                                                        >
                                                            <Checkbox
                                                                checked={columns.includes(
                                                                    colName
                                                                )}
                                                                sx={{
                                                                    marginRight: 1, // optional spacing for better readability
                                                                }}
                                                            />
                                                            {colName}
                                                        </TableCell>
                                                    ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {/* Render the first 10 rows of the file */}
                                            {fileContent
                                                .slice(0, 10)
                                                .map((row, rowIndex) => (
                                                    <TableRow key={rowIndex}>
                                                        {Object.values(row).map(
                                                            (
                                                                cell,
                                                                cellIndex
                                                            ) => (
                                                                <TableCell
                                                                    key={
                                                                        cellIndex
                                                                    }
                                                                    sx={{
                                                                        border:
                                                                            '1px solid grey', // This line adds the borders
                                                                        verticalAlign:
                                                                            'top', // this style aligns content to the top
                                                                    }}
                                                                >
                                                                    {cell}
                                                                </TableCell>
                                                            )
                                                        )}
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <Grid
                            container
                            spacing={8}
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <Grid item xs={12} sm={6}>
                                <FormControl
                                    fullWidth
                                    sx={{
                                        marginTop: 1,
                                        marginBottom: 2,
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={advancedSettings}
                                                onChange={event =>
                                                    setAdvancedSettings(
                                                        event.target.checked
                                                    )
                                                }
                                            />
                                        }
                                        label="Show advanced text analysis settings"
                                    />
                                </FormControl>
                                {advancedSettings && (
                                    <>
                                        <FormControl
                                            fullWidth
                                            sx={{
                                                marginTop: 1,
                                                marginBottom: 2,
                                            }}
                                        >
                                            <InputLabel id="superlinkedColumn-label">
                                                Superlinked column:
                                            </InputLabel>
                                            <Select
                                                labelId="superlinkedColumn-label"
                                                id="superlinkedColumn"
                                                value={superlinkedColumn}
                                                onChange={event =>
                                                    setSuperlinkedColumn(
                                                        event.target.value
                                                    )
                                                }
                                                label="Superlinked Column:"
                                            >
                                                <MenuItem value={'none'}>
                                                    None (Recommended)
                                                </MenuItem>
                                                {fileContent.length > 0 &&
                                                    Object.keys(
                                                        fileContent[0]
                                                    ).map((colName, index) => (
                                                        <MenuItem
                                                            value={colName}
                                                        >
                                                            {colName}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                            <FormHelperText
                                                sx={{ marginTop: 1 }}
                                            >
                                                Link the values in this column
                                                to all other values in the rows
                                                of other selected columns.
                                            </FormHelperText>
                                        </FormControl>
                                        <FormControl
                                            fullWidth
                                            sx={{
                                                marginTop: 2,
                                                marginBottom: 2,
                                            }}
                                        >
                                            <InputLabel id="splitByColumn-label">
                                                Split into separate Graphs by
                                                column:
                                            </InputLabel>
                                            <Select
                                                labelId="splitByColumn-label"
                                                id="splitByColumn"
                                                value={splitByColumn}
                                                onChange={event =>
                                                    setSplitByColumn(
                                                        event.target.value
                                                    )
                                                }
                                                label="Split Into Separate Graphs by Column:"
                                            >
                                                <MenuItem
                                                    value={'none'}
                                                    key="0"
                                                >
                                                    None (Recommended)
                                                </MenuItem>
                                                {fileContent.length > 0 &&
                                                    Object.keys(
                                                        fileContent[0]
                                                    ).map((colName, index) => (
                                                        <MenuItem
                                                            value={colName}
                                                            key={index + 1}
                                                        >
                                                            {colName}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                            <FormHelperText
                                                sx={{ marginTop: 1 }}
                                            >
                                                Separate the imported data into
                                                different graphs named after the
                                                distinct values found in this
                                                column above.
                                            </FormHelperText>
                                        </FormControl>
                                    </>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {advancedSettings && (
                                    <>
                                        <FormControl
                                            fullWidth
                                            sx={{
                                                marginTop: 8,
                                                marginBottom: 2,
                                            }}
                                        >
                                            <InputLabel id="modifyAnalyzedText-label">
                                                Build a knowledge graph from
                                            </InputLabel>
                                            <Select
                                                labelId="modifyAnalyzedText-label"
                                                id="modifyAnalyzedText"
                                                value={modifyAnalyzedText}
                                                onChange={event =>
                                                    setModifyAnalyzedText(
                                                        event.target.value
                                                    )
                                                }
                                                label="Build a knowledge graph from"
                                            >
                                                <MenuItem
                                                    value={'none'}
                                                    key="1"
                                                >
                                                    Words used in selected
                                                    column cells
                                                </MenuItem>
                                                <MenuItem
                                                    value={'commaSeparated'}
                                                    key="1"
                                                >
                                                    Comma-separated values in
                                                    selected column cells
                                                </MenuItem>
                                                <MenuItem
                                                    value={'detectEntities'}
                                                    key="2"
                                                >
                                                    Words and entities extracted
                                                    from selected column cells
                                                </MenuItem>
                                                <MenuItem
                                                    value={
                                                        'extractEntitiesOnly'
                                                    }
                                                    key="3"
                                                >
                                                    Only the entities extracted
                                                    from selected column cells
                                                </MenuItem>
                                                <MenuItem
                                                    value={'convertToEntities'}
                                                    key=""
                                                >
                                                    Tag the whole cell text as
                                                    an entity, connect to values
                                                    in the same row
                                                </MenuItem>
                                            </Select>
                                            <FormHelperText
                                                sx={{ marginTop: 1 }}
                                            >
                                                By default, we build a graph
                                                from the words used in your
                                                text. If you choose "Words and
                                                entities" or "Only the
                                                entities", we will identify and
                                                tag those for you. If you choose
                                                "Tag the whole text as entity",
                                                we will treat the whole cell
                                                value as a graph node.
                                            </FormHelperText>
                                        </FormControl>
                                        {modifyAnalyzedText != 'none' && (
                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 2,
                                                    marginBottom: 4,
                                                }}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            id="replaceEntities"
                                                            checked={
                                                                replaceEntities
                                                            }
                                                            onChange={event =>
                                                                setReplaceEntities(
                                                                    event.target
                                                                        .checked
                                                                )
                                                            }
                                                        />
                                                    }
                                                    label="Replace entities with root concepts"
                                                />
                                                {replaceEntities && (
                                                    <FormHelperText
                                                        id="replaceEntities-helperText"
                                                        sx={{ marginTop: 1 }}
                                                    >
                                                        When turned on, we will
                                                        not only detect the
                                                        entities, but also
                                                        replace them with their
                                                        ontological root
                                                        concepts throughout your
                                                        text.
                                                    </FormHelperText>
                                                )}
                                            </FormControl>
                                        )}
                                        <FormControl
                                            fullWidth
                                            sx={{
                                                marginTop: 1,
                                                marginBottom: 2,
                                            }}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={
                                                            removeDuplicates
                                                        }
                                                        onChange={event =>
                                                            setRemoveDuplicates(
                                                                event.target
                                                                    .checked
                                                            )
                                                        }
                                                    />
                                                }
                                                label="Remove duplicate statements"
                                            />
                                        </FormControl>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </>
                )}
                {activeStep === 2 && (
                    <>
                        <DialogContent
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <Typography
                                variant="subtitle1" // or another variant appropriate for your design
                                sx={{
                                    fontWeight: 'bold',
                                }}
                            >
                                3. Please, select the columns you'd like to use
                                as filter tags
                            </Typography>

                            <Typography
                                variant="subtitle2" // or another variant appropriate for your design
                                sx={{ marginTop: 1, maxWidth: 600 }}
                            >
                                You can choose several columns to filter your
                                data by in the graph: e.g. gender, location,
                                sentiment, type of product. All distinct values
                                inside the columns you choose will be added as
                                tags.
                            </Typography>

                            <Grid container spacing={8}>
                                <Grid item xs={12} sm={12}>
                                    <Table
                                        sx={{
                                            borderCollapse: 'collapse',
                                            marginTop: 2,
                                        }}
                                    >
                                        <TableHead>
                                            <TableRow variant="head">
                                                {/* Render column headers with checkboxes */}
                                                {fileContent.length > 0 &&
                                                    Object.keys(
                                                        fileContent[0]
                                                    ).map((colName, index) => (
                                                        <TableCell
                                                            key={index}
                                                            sx={{
                                                                border:
                                                                    '1px solid grey', // This line adds the borders
                                                                verticalAlign:
                                                                    'top', // this style aligns content to the top
                                                                whiteSpace:
                                                                    'nowrap', // prevent text from wrapping to the next line
                                                                backgroundColor: theme =>
                                                                    theme
                                                                        .palette
                                                                        .mode ===
                                                                    'dark'
                                                                        ? '#222 !important'
                                                                        : '#ddd !important',
                                                                color: theme =>
                                                                    theme
                                                                        .palette
                                                                        .mode ===
                                                                    'dark'
                                                                        ? '#fff !important'
                                                                        : '#000 !important',
                                                                cursor:
                                                                    'pointer',
                                                            }}
                                                            onClick={() =>
                                                                handleFilterSelection(
                                                                    colName
                                                                )
                                                            }
                                                        >
                                                            <Checkbox
                                                                checked={filters.includes(
                                                                    colName
                                                                )}
                                                                sx={{
                                                                    marginRight: 1, // optional spacing for better readability
                                                                }}
                                                            />
                                                            {colName}
                                                        </TableCell>
                                                    ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {/* Render the first 10 rows of the file */}
                                            {fileContent
                                                .slice(0, 10)
                                                .map((row, rowIndex) => (
                                                    <TableRow key={rowIndex}>
                                                        {Object.values(row).map(
                                                            (
                                                                cell,
                                                                cellIndex
                                                            ) => (
                                                                <TableCell
                                                                    key={
                                                                        cellIndex
                                                                    }
                                                                    sx={{
                                                                        border:
                                                                            '1px solid grey', // This line adds the borders
                                                                        verticalAlign:
                                                                            'top', // this style aligns content to the top
                                                                    }}
                                                                >
                                                                    {cell}
                                                                </TableCell>
                                                            )
                                                        )}
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </Grid>
                            </Grid>
                        </DialogContent>

                        <Grid
                            container
                            spacing={8}
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <Grid item xs={12} sm={6}>
                                <FormControl
                                    fullWidth
                                    sx={{
                                        marginTop: 2,
                                        marginBottom: 2,
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={advancedFilterSettings}
                                                onChange={event =>
                                                    setAdvancedFilterSettings(
                                                        event.target.checked
                                                    )
                                                }
                                            />
                                        }
                                        label="Show advanced filter settings"
                                    />
                                </FormControl>
                                {advancedFilterSettings && (
                                    <FormControl
                                        fullWidth
                                        sx={{
                                            marginTop: 4.5,
                                            marginBottom: 2,
                                        }}
                                    >
                                        <InputLabel id="columnForTimestamp-label">
                                            Column to use for the timestamp:
                                        </InputLabel>
                                        <Select
                                            labelId="columnForTimestamp-label"
                                            id="columnForTimestamp"
                                            value={columnForTimestamp}
                                            onChange={event =>
                                                setColumnForTimestamp(
                                                    event.target.value
                                                )
                                            }
                                            label="Column to use for the timestamp:"
                                        >
                                            <MenuItem value={'none'} key="0">
                                                None
                                            </MenuItem>
                                            {fileContent.length > 0 &&
                                                Object.keys(fileContent[0]).map(
                                                    (colName, index) => (
                                                        <MenuItem
                                                            key={index + 1}
                                                            value={colName}
                                                        >
                                                            {colName}
                                                        </MenuItem>
                                                    )
                                                )}
                                        </Select>
                                        <FormHelperText sx={{ marginTop: 1 }}>
                                            Preferred format: mm/dd/yyyy. If you
                                            select a column, you can use it to
                                            filter results by different
                                            timeframes.
                                        </FormHelperText>
                                    </FormControl>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {advancedFilterSettings && (
                                    <>
                                        <FormControl
                                            fullWidth
                                            sx={{
                                                marginTop: 2,
                                                marginBottom: 2,
                                            }}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={
                                                            addColumnNameToFilter
                                                        }
                                                        onChange={event =>
                                                            setAddColumnNameToFilter(
                                                                event.target
                                                                    .checked
                                                            )
                                                        }
                                                    />
                                                }
                                                label="Add column name to filter value"
                                            />
                                            <FormHelperText
                                                sx={{ marginTop: 0 }}
                                            >
                                                e.g. Location: USA or Person:
                                                John. Will shorten the column
                                                name for brevity.
                                            </FormHelperText>
                                        </FormControl>
                                        <FormControl
                                            fullWidth
                                            sx={{ marginTop: 2 }}
                                        >
                                            <EditableSelect
                                                id="universalTag"
                                                label={'Tag all data with'}
                                                initialValue={universalTag}
                                                onChange={name =>
                                                    setUniversalTag(
                                                        slugifyString(name)
                                                    )
                                                }
                                                placeholder={`e.g. ${slugifyString(
                                                    fileName
                                                )}`}
                                            />
                                            <FormHelperText
                                                sx={{ marginTop: 1 }}
                                            >
                                                Tag all imported data with this
                                                value, so you can use it as a
                                                filter. Leave empty for none.
                                            </FormHelperText>
                                        </FormControl>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </>
                )}
                {activeStep === 3 && (
                    <>
                        <DialogContent
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <Grid container spacing={8}>
                                <Grid item xs={12} sm={5}>
                                    <DialogContentText>
                                        <Typography
                                            variant="subtitle1" // or another variant appropriate for your design
                                            sx={{
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            4. Please, choose the context to
                                            import your content to:
                                        </Typography>
                                    </DialogContentText>
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 4 }}
                                    >
                                        <EditableSelect
                                            selectItems={contextNames}
                                            label={'Contexts'}
                                            initialValue={selectedContext}
                                            onChange={name =>
                                                addToSelectedContext(name)
                                            }
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    {' '}
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </>
                )}
                {activeStep === 4 && (
                    <ImportingNotice
                        linkHref={`/${username}/${selectedContext}/edit`}
                    />
                )}
                <DialogActions
                    sx={{
                        paddingRight: 4,
                        paddingLeft: 4,
                        paddingBottom: 4,
                        paddingTop: 2,
                    }}
                >
                    {/* <Button onClick={onClose} variant="outlined">
                        Cancel
                    </Button> */}
                    <Button
                        color="inherit"
                        variant="outlined"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1, px: 3, py: 1, fontSize: '0.95rem' }}
                    >
                        Back
                    </Button>
                    {/* {isStepOptional(activeStep) && (
                        <Button
                            color="inherit"
                            onClick={handleSkip}
                            sx={{ mr: 1 }}
                        >
                            Skip
                        </Button>
                    )} */}
                    <LoadingButton
                        color="info"
                        variant="contained"
                        size="large"
                        endIcon={<ArrowForwardIcon />}
                        disabled={!files.length > 0}
                        onClick={handleNext}
                        sx={{ px: 4, py: 1, fontSize: '0.95rem' }}
                    >
                        {activeStep === steps.length - 1 ? 'Visualize' : 'Next'}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

function renderImportOptionsMenu(receivedMenuItems) {
    const theme = useTheme()

    return (
        <Container
            sx={{
                py: 1,
                [theme.breakpoints.up('sm')]: {
                    pl: 0,
                },
                pt: 4,
            }}
            maxWidth={false}
        >
            <Grid
                container
                rowSpacing={3}
                justifyContent="flex-start"
                columnSpacing={3}
                alignItems="flex-start"
                pr={0}
            >
                {receivedMenuItems.map(card => (
                    <Grid item key={card.name} alignItems="flex-start" pr={0}>
                        <SubImportMenuItem {...card} />
                    </Grid>
                ))}
            </Grid>
        </Container>
    )
}

function generatePresetContext(type, fileName) {
    const dateAndTime = new Date()
        .toISOString()
        .slice(2, 16)
        .replace(/-/g, '')
        .replace(/:/g, '')

    const typeString = type ? `${slugifyString(type)}_` : 'csv_'
    const nameString = fileName
        ? slugifyString(fileName).slice(0, 12)
        : dateAndTime

    return `${typeString}${nameString}`
}

const determineFileType = file => {
    if (file.type === 'application/vnd.ms-excel') return '.csv'
    else if (file.name.endsWith('.csv')) return '.csv'
    else return null
}

function removeUnicodeControls(str) {
    return str.replace(
        /[\u0000-\u001F\u007F-\u009F\uFEFF\u200B\u200C\u200D]/g,
        ''
    )
}
